import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-animation',
  templateUrl: './success-animation.component.html',
  styleUrls: ['./success-animation.component.scss']
})
export class SuccessAnimationComponent implements OnInit {
  @Input() size = 140;
  @Input() color;

  constructor() {}

  ngOnInit() {}
}
